module.exports = __webpack_public_path__ + "img/1.2fdb6d55.png";